import { render, staticRenderFns } from "./info-card-mobile.vue?vue&type=template&id=a30a9070&lang=pug&"
import script from "./info-card-mobile.vue?vue&type=script&lang=js&"
export * from "./info-card-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports